"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function thumbCommon(theme) {
  return "\n  height: 16px;\n  width: 16px;\n  border-radius: 100%;\n  background: ".concat(theme.palette.primary[0], ";\n  cursor: pointer;\n");
}

const trackCommon = theme => "\n  width: 100%;\n  height: 4px;\n  cursor: pointer;\n  background: ".concat((0, _polished.lighten)(0.25, theme.palette.primary[0]), ";\n  border-radius: 1rem;\n  margin-bottom: 6px;\n");

const RangeSelector = _styledComponents.default.input.attrs({
  type: 'range'
}).withConfig({
  displayName: "RangeSelector"
})(["&::-webkit-slider-thumb{", " -webkit-appearance:none;margin-top:-6px;}&::-moz-range-thumb{", ";}&::-ms-thumb{", ";}&::-webkit-slider-runnable-track{", ";}&::-moz-range-track{", ";}&::-ms-track{", " background:transparent;border-color:transparent;border-width:16px 0;color:transparent;}&::-ms-fill-lower,&::-ms-fill-upper{", ";}"], ({
  theme
}) => thumbCommon(theme), ({
  theme
}) => thumbCommon(theme), ({
  theme
}) => thumbCommon(theme), ({
  theme
}) => trackCommon(theme), ({
  theme
}) => trackCommon(theme), ({
  theme
}) => trackCommon(theme), ({
  theme
}) => trackCommon(theme));

var _default = RangeSelector;
exports.default = _default;